export default "__VITE_ASSET__907114a5__"